
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/planning-updates/[...referenceSegments]",
      function () {
        return require("private-next-pages/planning-updates/[...referenceSegments].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/planning-updates/[...referenceSegments]"])
      });
    }
  